<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5a4t4u/images/9781429941938.jpg?1727387913425" alt="This image is the cover for the book Waking Up in Dixie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waking Up in Dixie
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>From the </i>New York Times <i>bestselling author of </i>The Red Hat Club <i>comes a hilarious story of marriage and love and second chances <br/><br/></i></b>When Elizabeth Mooney escaped the shame of her "white trash" family to marry the crown prince of her small town, Howell Whittington, she never dreamed that thirty years later, she'd end up trapped in a loveless marriage to the cruel banker who's foreclosing on all her friends. Then Howe has a stroke sitting up in church, and when he wakes up, he's at the mercy of all his appetites and emotions. Transformed, Howe wants to be a real husband, which scares proper, repressed Elizabeth to death, and setting out to right past wrongs, he blackmails the town's baddies into doing the right thing by threatening to foreclose on their mortgages. The ensuing hilarious rollercoaster ride wakes up not only Elizabeth and their marriage, but the whole town and its hidebound institutions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Haywood Smith
      </h2>
      
      <p class="authorDescription body article"><P>HAYWOOD SMITH is the <I>New York Times </I>and <I>USA Today </I>bestselling author of <I>Ladies of the Lake, Wedding Belles, Red Hat Club </I>and <I>The Red Hat Club Rides Again. <br><br></I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2540218a